import { required } from 'vuelidate/lib/validators';

export default {
    productName: {
        required
    },
    number: {},
    harmonizedCode: {},
    commodity: {},
    countryOfOrigin: {},
    unitPrice: {},
    currency: {},
    weight: { required },
    length: { required },
    width: { required },
    height: { required },
    dryIceWeight: {},
    packageType: { required }
};